import React from "react";

const peso = (value) => {
  return Number(value || 0).toLocaleString("en-PH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const InvoiceItems = ({ items }) => {
  return (
    <table className="invoice-table">

      <thead>

        <tr>

          <th style={{ width: "7%" }}>LOT</th>

          <th style={{ width: "18%" }}>ARTIST</th>

          <th>TITLE / DESCRIPTION</th>

          <th style={{ width: "12%" }}>HAMMER</th>

          <th style={{ width: "12%" }}>PREMIUM</th>



          <th style={{ width: "14%" }}>TOTAL</th>

        </tr>

      </thead>

      <tbody>

        {items.map((item, index) => (

          <tr key={index}>

            <td className="center">
              {item.lotNumber}
            </td>

            <td>
              {item.artist}
            </td>

            <td>

              <strong>

                {item.artworkTitle}

              </strong>

              <br />

              <small>

                {item.medium}

              </small>

            </td>

            <td className="right">

              ₱{peso(item.hammerPrice)}

            </td>

            <td className="right">

              ₱{peso(item.premium)}

            </td>

            

            <td className="right">

              <strong>

                ₱{peso(item.total)}

              </strong>

            </td>

          </tr>

        ))}

      </tbody>

    </table>
  );
};

export default InvoiceItems;